export default __webpack_public_path__ + "static/media/devguide12.1f0bb46f.md";